// extracted by mini-css-extract-plugin
module.exports = {"option":"Bracelet_option__cl6Go","selected":"Bracelet_selected__CeJUW","lengthTable":"Bracelet_lengthTable__6KD7o"};